import React from 'react';
import Dialog from '../common/Dialog';
import ModalActions from '../common/ModalActions';
import './ClassPhotoTrialGate.css';

const DEFAULT_TITLE = '방금 만든 우리반 작품으로 끝까지 만들어보세요';
const DEFAULT_DESCRIPTION = '가입하면 7일 동안 PRO가 자동으로 시작되고, 지금 만든 이미지와 내용도 그대로 이어져요.';
const DEFAULT_BENEFITS = [
  '이미지 수정·추가 생성',
  'PPT·학습지 다운로드',
  '만든 자료 자동 저장',
];

const CheckIcon = () => (
  <svg
    aria-hidden="true"
    className="class-photo-trial-gate__check"
    focusable="false"
    height="16"
    viewBox="0 0 16 16"
    width="16"
  >
    <path
      d="M3.5 8.4 6.6 11.4 12.6 4.9"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
);

/**
 * 7일 PRO 체험 게이트. 기본 문구는 우리반 AI 프사 기준이며,
 * 다른 이벤트(한글 파일 등)는 `title`·`description`·`benefits` 로 문구만 바꿔 쓴다.
 *
 * `exhausted`({ message, label, onClick })를 넘기면 체험을 이미 쓴 사용자용 화면으로 바뀐다:
 * 설명 자리에 message, 주 버튼은 label(요금제 이동). 넘기지 않는 기존 이벤트는 그대로다.
 */
const ClassPhotoTrialGate = ({
  benefits = DEFAULT_BENEFITS,
  description = DEFAULT_DESCRIPTION,
  exhausted = null,
  isOpen,
  intentLabel = '계속 만들기',
  loading = false,
  onClose,
  onStart,
  title = DEFAULT_TITLE,
}) => (
  <Dialog
    align="center"
    description={exhausted?.message || description}
    dismissible
    eyebrow={exhausted ? 'PRO로 계속' : '카드 등록 없이 바로 시작'}
    footer={(
      <ModalActions
        primary={exhausted
          ? { label: exhausted.label || 'PRO로 계속 만들기', onClick: exhausted.onClick, testId: 'class-photo-trial-gate-pricing' }
          : { label: `7일 PRO 무료로 ${intentLabel}`, onClick: onStart, loading: Boolean(loading) }}
        tertiary={{ label: '결과로 돌아가기', onClick: onClose }}
      />
    )}
    icon={(
      <span aria-hidden="true" className="class-photo-trial-gate__icon">7일</span>
    )}
    onClose={onClose}
    open={Boolean(isOpen)}
    size="sm"
    testId="class-photo-trial-gate"
    title={title}
  >
    <ul className="class-photo-trial-gate__benefits">
      {(Array.isArray(benefits) && benefits.length ? benefits : DEFAULT_BENEFITS).map((benefit) => (
        <li key={benefit}>
          <CheckIcon />
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
  </Dialog>
);

export default ClassPhotoTrialGate;
